"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactAvatar = _interopRequireDefault(require("react-avatar"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _system = require("@mui/system");
var _Text = _interopRequireDefault(require("../Text"));
var _theme = require("../../theme");
/**
 * 
 * @param {*} param0 
 */
var MasterMetaMenu = function MasterMetaMenu(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    anchorEl = _ref.anchorEl,
    toggleModal = _ref.toggleModal,
    handleCloseMenu = _ref.handleCloseMenu,
    logout = _ref.logout,
    name = _ref.name,
    email = _ref.email,
    classes = _ref.classes,
    testid = _ref.testid;
  var StyledMenu = (0, _system.styled)(_Menu["default"])({
    '& .MuiPaper-root': {
      borderRadius: 8,
      minWidth: 240
    },
    borderBottom: "".concat(_theme.colors.surface, " solid 1px")
  });
  var StyledMenuItem = (0, _system.styled)(_MenuItem["default"])({
    height: 'auto',
    justifyContent: 'center',
    minWidth: '100%',
    padding: '5px',
    paddingTop: '10px'
  });
  var TopMenuItem = (0, _system.styled)("div")({
    padding: '30px',
    paddingTop: '20px',
    textAlign: 'center'
  });
  return /*#__PURE__*/_react["default"].createElement(StyledMenu, {
    anchorEl: anchorEl,
    open: open,
    onClose: onClose,
    disableAutoFocusItem: true,
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      borderBottom: "".concat(_theme.colors.surface, " solid 1px")
    }
  }, /*#__PURE__*/_react["default"].createElement(TopMenuItem, null, /*#__PURE__*/_react["default"].createElement(_reactAvatar["default"], {
    name: name,
    size: "55",
    textSizeRatio: 2.2,
    round: false,
    color: _theme.colors.skyBlue,
    style: {
      marginBottom: 20
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    testid: testid,
    align: 'center',
    medium: true,
    bold: true,
    display: "block"
  }, name), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: 'center',
    medium: true,
    light: true,
    display: "block"
  }, email))), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: function onClick() {
      return toggleModal('showSettingsModal');
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block",
    customLinkStyle: {
      textDecoration: 'none'
    }
  }, "Settings")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block"
  }, "Resources")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: handleCloseMenu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    align: "center",
    medium: true,
    display: "block"
  }, "Contact Support")), /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
    onClick: logout
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.red,
    align: "center",
    medium: true,
    display: "block"
  }, "Logout")));
};
var _default = exports["default"] = MasterMetaMenu;